import { TITLE } from '@/config/defaultSetting';

const title = TITLE || 'sso-webclient';

const getPageTitle = (
  pageTitle: any,
  redirectUrl?: string | (string | null)[] | null
) => {
  if (pageTitle) {
    if (redirectUrl) {
      if (redirectUrl.includes('ods')) {
        return `${pageTitle} - ODS订单调度中心`;
      } else if (redirectUrl.includes('tms')) {
        return `${pageTitle} - TMS协同平台`;
      } else if (redirectUrl.includes('fpl')) {
        return `${pageTitle} - FPL平台`;
      }
    } else {
      return `${pageTitle} - 4PL物流协同平台`;
    }
  } else {
    return `${title}`;
  }
};

export default getPageTitle;
